import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from '../../../../services/admin.service';

@Component({
  selector: 'app-change-salary',
  templateUrl: './change-salary.component.html',
  styleUrls: ['./change-salary.component.css']
})

export class ChangeSalaryComponent implements OnInit {

  public id: string;  
  private value: number = null;

  public disabledBtn = false; 
  public successInfo = false;
  public errorInfo = false;
  changeLog;

  constructor(public activeModal: NgbActiveModal,
    private adminService: AdminService) {
  }

  ngOnInit() {
  }

  setId(id) {
    this.id = id;
  }

  setValue(value) {
    this.value = value;
  }

  change(value) {
    if(value > 999999) {
      this.value = 999999
    }  
    if(value < 0) {
      this.value = 0
    } 
  }


  renameGroup() {
    this.disabledBtn = true;
    this.successInfo = false;
    this.errorInfo = false;

      this.adminService.changeSalaryValue(this.id, String(this.value), this.changeLog).subscribe(
        (res: any) => {
            this.successInfo = true;
            this.errorInfo = false;
            this.disabledBtn = false;
            this.activeModal.close('ok');
        },
        () => {
          this.errorInfo = true;
        }
      );
  }

  disableBtnValidation() {
    return this.value === null;
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/views/view-user-profile/change-salary/change-salary.component.ts